<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-preface element-with-heading" id="vol-1-preface">
<div class="heading heading-with-title heading-without-image" id="vol-1-preface-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Preface</h1>
</div>
</div>
</div>
</div>
<div class="text" id="vol-1-preface-text">
<p class="first first-in-chapter first-full-width">‘Being psycho doesn’t make you bad, being bad makes you bad. Being psycho and bad makes you dangerous. That’s what my school report should have said but it didn’t, and now the consequences of that oversight are everywhere.</p>
<p class="subsq">‘I killed for pleasure, now I kill out of a sense of duty. You understand that, right? Not sure which one I prefer more.</p>
<p class="subsq">‘No wait … I do know … killing family is best. You get to stick around and watch the fallout.</p>
<p class="subsq">‘This is not my fault.</p>
<p class="subsq">‘As the next few weeks play out, I want you to remember, it’s not my fault.</p>
<p class="subsq">‘It’s yours.’</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol001preface.vue?25e16af1